export const isFullName = (name) => {
  if (typeof name !== 'string') return false;

  const words = name.trim().split(/\s+/);
  if (words.length < 2) return false;

  return words.every((word) => /^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ'’-]*$/.test(word));
};
